import { APP_INITIALIZER, Provider } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { environment } from 'src/environments/environment';
import {
  initializeEnvironmentConfig,
  preloadLanguage,
  preLoadToken
} from './app-initializer';
import { LANGS } from './constants/lang.const';
import { AuthService } from './services/auth.service';
import { TranslocoHttpLoader } from './services/transloco-http-loader.service';

export const TRANSLOCO_CONFIG = {
  config: {
    availableLangs: [...LANGS],
    defaultLang: 'engb',
    fallbackLang: 'engb',
    // Remove this option if your application doesn't support changing language in runtime.
    reRenderOnLangChange: true,
    prodMode: environment.production
  },
  loader: TranslocoHttpLoader
};

export const APP_INITIALIZERS: Provider[] = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: preLoadToken,
    deps: [AuthService]
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: preloadLanguage,
    deps: [TranslocoService]
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: initializeEnvironmentConfig
  }
];
